<script setup>
import IntlTelInput from 'intl-tel-input/vueWithUtils';
import TelInput from 'intl-tel-input/intlTelInputWithUtils';
import { computed, nextTick, onMounted, ref } from 'vue';
import _ from '@/lib/lodash';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  label: {
    type: String,
    default() {
      return '';
    },
  },
  placeholder: {
    type: [String, Number],
    default() {
      return '';
    },
  },
  type: {
    type: String,
    default() {
      return 'default';
    },
  },
  initialCountry: {
    type: String,
    default() {
      return '';
    },
  },
  error: {
    type: [String, Number, Array],
    default() {
      return '';
    },
  },
  errorClearOnChange: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue', 'update:error']);
const uiInputPhone = ref();
const instance = ref();


const currentError = computed(() => {
  return _.isArray(props.error) ? props.error[0].message : props.error;
});

const handleInput = async () => {
  await nextTick();
  emit('update:modelValue', instance.value.getNumber(TelInput.utils.numberFormat.E164));

  if (props.errorClearOnChange) {
    emit('update:error', null);
  }
};

onMounted(() => {
  instance.value = uiInputPhone.value.instance;
});
</script>

<template>
  <div
    :class="[
      'ui-input-phone',
      `ui-input-phone_${type}`,
      { 'ui-input-phone_error': currentError },
    ]"
  >
    <UiLabel
      v-if="label"
      :label="label"
      :type="type"
    />
    <IntlTelInput
      ref="uiInputPhone"
      :input-props="{
        placeholder: placeholder,
        type: 'tel'
      }"
      :model-value="modelValue"
      :options="{
        initialCountry: initialCountry,
        countrySearch: false,
        formatOnDisplay: true,
        nationalMode: false,
      }"
      :value="modelValue"
      class="ui-input-phone__element"
      @update:model-value="handleInput"
    />

    <UiHelp
      v-if="currentError"
      :is-error="true"
      :text="currentError"
    />
  </div>
</template>

<style lang="scss">


.ui-input-phone {
  width: 100%;

  &__element {
    font-family: "Open Sans", sans-serif;
    display: flex;
    align-items: center;
    min-width: 10%;
    max-width: 100%;
    flex: 10 1 auto;
    border: none;
    outline: none;
    background: transparent;
    font-size: 13px;
    color: #303634;
    transition: border-color 0.2s;
    overflow: hidden;
    box-sizing: border-box;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;
      color: #ffffff !important;
    }
  }

  &_default & {
    &__element {
      border: 1px solid #d9d9d9;
      border-radius: 8px;
      height: 34px;
    }
  }

  &_registration & {
    &__element {
      font-size: 14px;
      border-bottom: 2px solid #ccc;
      border-radius: 0;
      padding: 0;
      height: 45px;
    }
  }


  &_error & {
    &__element {
      border-color: #ff5c70;
    }
  }

  &__element:focus {
    border-color: var(--color-border);
  }

  .iti,
  input {
    width: 100%;
  }
}
</style>